module.exports = __webpack_public_path__ + "static/media/looksy-04.5678bcaf.jpg";